// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"ac06bbf7","292":"c6253a14"}[chunkId] + ".css";
};